import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=2d5ee868&scoped=true"
import script from "./accept.vue?vue&type=script&lang=js"
export * from "./accept.vue?vue&type=script&lang=js"
import style0 from "./accept.vue?vue&type=style&index=0&id=2d5ee868&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ee868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5ee868')) {
      api.createRecord('2d5ee868', component.options)
    } else {
      api.reload('2d5ee868', component.options)
    }
    module.hot.accept("./accept.vue?vue&type=template&id=2d5ee868&scoped=true", function () {
      api.rerender('2d5ee868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/accept.vue"
export default component.exports